module.exports = __webpack_public_path__ + "img/imagen_header.290b964f.jpg";